import './component';
import './preview';

Shopware.Service('cmsService').registerCmsBlock({
    name: 'acris-blog-subtitle',
    label: 'acris-blog.blocks.blogSubtitle.label',
    category: 'acris-blog',
    component: 'sw-cms-block-acris-blog-subtitle',
    previewComponent: 'sw-cms-preview-acris-blog-subtitle',
    defaultConfig: {
        marginBottom: '20px',
        marginTop: '20px',
        marginLeft: null,
        marginRight: null,
        sizingMode: 'boxed'
    },
    slots: {
        column: {
            type: 'acris-blog-subtitle'
        },
    }
});
